// Third-party library imports.
import React from 'react';
import PropTypes from 'prop-types';

// Local repo imports.
import PaletteRow from '../PaletteRow';
import { EMPTY_ARRAY, EMPTY_STRING, NO_OP } from '../../../constants/Constants';
import '../CheckboxPalette.scss';
class PaletteContent extends React.PureComponent {
  constructor() {
    var _this;
    super(...arguments);
    _this = this;
    this.handleRowClick = function (rowIds, updatedActionData, subKeys) {
      let isSubAction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      const {
        contentAccessor,
        onContentChange
      } = _this.props;
      onContentChange(contentAccessor, rowIds, updatedActionData, subKeys, isSubAction);
    };
    this.handleExpandClick = rowIndex => {
      const {
        contentAccessor,
        onExpand
      } = this.props;
      onExpand(rowIndex, contentAccessor);
    };
  }
  render() {
    const {
      content
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: "palette-content"
    }, content.map((row, index) => {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PaletteRow, {
        key: row.key,
        rowId: row.key,
        rowIndex: index,
        rowData: row,
        onRowClick: this.handleRowClick,
        onExpand: this.handleExpandClick
      }));
    }));
  }
}
PaletteContent.propTypes = {
  content: PropTypes.array,
  onContentChange: PropTypes.func,
  contentAccessor: PropTypes.string
};
PaletteContent.defaultProps = {
  content: EMPTY_ARRAY,
  onContentChange: NO_OP,
  contentAccessor: EMPTY_STRING
};
export default PaletteContent;